export enum FeeType {
    DAILY_DECAYING_FEE = 'DAILY_DECAYING_FEE',
    FLAT_FEE = 'FLAT_FEE',
    NOT_SET = 'NOT_SET'
}
export enum FeeTypeDisplayValue {
    DAILY_DECAYING_FEE = 'Daily Decaying Fee Rate',
    FLAT_FEE = 'Flat Fee Rate',
    NOT_SET = 'No Fee Type Configured'
}

export enum PaymentMethodStatusDisplay {
    UNREGISTERED = 'None',
    IN_REVIEW = 'In Review',
    VERIFIED = 'Verified',
    REJECTED = 'Rejected'
}

export enum PaymentMethodTypeDisplay {
    ACH = 'Bank ACH',
    WIRE = 'Wire Transfer'
}

export enum EnrollmentStatus {
    UNKNOWN_ENROLLMENT_STATUS = 'UNKNOWN_ENROLLMENT_STATUS',
    ELIGIBLE = 'ELIGIBLE',
    INELIGIBLE = 'INELIGIBLE',
    INVITED = 'INVITED',
    USER_CREATED = 'USER_CREATED',
    ENROLLED = 'ENROLLED',
    TRANSFERRED = 'TRANSFERRED',
    NOT_APPLICABLE = 'NOT_APPLICABLE'
}

export enum AutoVerifyStatus {
    CLOSED = 'CLOSED',
    OPEN = 'OPEN',
    UNKNOWN = 'UNKNOWN',
    ERROR = 'ERROR',
    UNCHECKED = 'UNCHECKED'
}

export enum AutoVerifyStatusDisplay {
    CLOSED = 'Closed',
    OPEN = 'Open',
    UNKNOWN = 'Unknown',
    UNCHECKED = 'Unchecked',
    ERROR = 'Error'
}
export interface ISettingsUiControl {
    feeStructure?: string;
    feeRate?: number;
    autoPayDiscount?: number;
    autopayCommitment?: number;
    buyerPaidEarlyPayment?: number;
    supplierPaidEarlyPayment?: number;
    buyerPaidDeliveryFees?: string;
    ineligibleDaysBeforeTerms?: number;
}
